import React from "react";
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import imag from "../../img/LOGO-Icontec-2019_hor_white.png"; // Ajusta la ruta según la ubicación de tu imagen

const Header = () => {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-3 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center">
              <Col xs="auto">
                <h1>
                  <font color="#FFFFFF">CONTRATOS</font>
                </h1>
              </Col>
              <Col className="text-right">
                <img
                  src={imag}
                  alt="Descripción de la imagen"
                  style={{ maxWidth: "300px", maxHeight: "100px" }}
                />
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
